import { AuthContext } from '@repo-level/core-front';
import { AddonsContext } from 'contexts/addons';
import { ModalsContext, ModalType } from 'contexts/modal';
import { AUTO_REGISTRATION_QUERY_NAME } from 'helpers/auth';
import { removeQueryParameterWithNavigation } from 'helpers/common';
import { X_SELL_USER_API } from 'helpers/constants';
import { showTooltip } from 'helpers/tooltip';
import { TooltipTypes } from 'modules/globalTooltip';
import { useCallback, useContext, useEffect } from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';

export const useUserByHash = () => {
  const {
    url: { query },
  } = useCurrentRoute();
  const navigation = useNavigation();

  const { handleModal } = useContext(ModalsContext);
  const { setAutoRegistrationData } = useContext(AddonsContext);

  const getUserByHash = useCallback(
    async (queryAutoReg: string, onError?: () => void) => {
      try {
        const user = await fetch(`${X_SELL_USER_API}/${queryAutoReg}`);
        const userDara = await user?.json();

        if (userDara) {
          setAutoRegistrationData(userDara);
          handleModal(ModalType.AutoRegistration)();
        }
      } catch (error) {
        setAutoRegistrationData(null);
        removeQueryParameterWithNavigation(
          navigation,
          query,
          AUTO_REGISTRATION_QUERY_NAME
        );
        showTooltip({
          type: TooltipTypes.ERROR,
          title: 'Hash is invalid',
        });

        onError && onError();
      }
    },
    [query, navigation, handleModal, setAutoRegistrationData]
  );

  return { getUserByHash };
};

export const useAutoRegistrationModal = () => {
  const {
    url: { query },
  } = useCurrentRoute();
  const navigation = useNavigation();
  const { getUserByHash } = useUserByHash();

  const { modalComponent } = useContext(ModalsContext);
  const { isAuthenticated, pendingUser } = useContext(AuthContext);

  useEffect(() => {
    if (pendingUser) return;

    const queryAutoReg = query[AUTO_REGISTRATION_QUERY_NAME];
    if (queryAutoReg && !modalComponent) {
      if (isAuthenticated) {
        removeQueryParameterWithNavigation(
          navigation,
          query,
          AUTO_REGISTRATION_QUERY_NAME
        );
        return;
      }

      getUserByHash(queryAutoReg);
    }
  }, [
    query,
    navigation,
    pendingUser,
    modalComponent,
    isAuthenticated,
    getUserByHash,
  ]);
};
